import { IGameProvider } from '@base/features/game/model/interfaces';
import LobbyService from '@base/features/lobby/model/lobbyService';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { useSubject } from '@base/utils/helpers';
import { container } from 'tsyringe';
import { CreateTable } from '@base/features/createTable/components/createTable';
import styles from '../styles/gamePage.module.scss';

const GamePage = () => {
  const gameProvider: IGameProvider = container.resolve('gameProvider');
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const lobbyService: LobbyService = container.resolve('lobbyService');
  useSubject(lobbyService.onMeJoinedTable);

  return playersOnlineRepository.me?.getTable() ? (
    gameProvider.getGameBoardView()
  ) : (
    <div className={styles.game}>
      <CreateTable />
    </div>
  );
};

export default GamePage;
